import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getCalendar } from '../services/jrOverview.js';

const WINDOWS = [30, 60, 90];

const fmt = (d) =>
  new Date(d).toLocaleDateString('cs-CZ', { weekday: 'short', day: 'numeric', month: 'numeric' });

export default function JrCalendar() {
  const [days, setDays] = useState(30);
  const [events, setEvents] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    setEvents(null);
    getCalendar(days)
      .then(setEvents)
      .catch((e) => setError(e.message || 'Kalendář se nepodařilo načíst.'));
  }, [days]);

  return (
    <section className="dashboard">
      <div className="dashboard__header">
        <div>
          <h1 className="dashboard__title">Kalendář a rytmus</h1>
          <p className="dashboard__lead">
            Pevné body z data nástupu a termínu zkoušky. Drill do kalendáře nezapisuje – ukazuje
            pevné body a upozorňuje před schůzkami. Události přidáváš v detailu makléře.
          </p>
        </div>
      </div>
      {error && <p className="dashboard__error" role="alert">{error}</p>}
      <div className="jr-filters">
        {WINDOWS.map((w) => (
          <button
            key={w}
            type="button"
            className={`button ${w === days ? 'button--spot' : 'button--secondary'}`}
            onClick={() => setDays(w)}
          >
            Okno {w} dní
          </button>
        ))}
      </div>
      <div className="card jr-table-wrap">
        <table className="jr-table">
          <thead>
            <tr><th>Kdy</th><th>Kdo</th><th>Co</th><th>Poznámka</th></tr>
          </thead>
          <tbody>
            {(events || []).map((e) => (
              <tr key={e.id}>
                <td>{fmt(e.date)}{e.window_end && e.window_end !== e.date ? ` – ${fmt(e.window_end)}` : ''}</td>
                <td>{e.makler_id ? <Link to={`/dashboard/database/${e.makler_id}`}>{e.makler}</Link> : e.makler}</td>
                <td>{e.title}{e.projected ? ' · orientační okno, ne rezervace' : ''}</td>
                <td>{e.description || ''}</td>
              </tr>
            ))}
            {events && events.length === 0 && (
              <tr><td colSpan={4}>V tomto okně nejsou žádné pevné body.</td></tr>
            )}
            {!events && !error && <tr><td colSpan={4}>Načítá se…</td></tr>}
          </tbody>
        </table>
      </div>
    </section>
  );
}
